export enum RoundingTypeAnnouncement {
    Standard = 0,
    RoundingUp = 1,
    RoundingDown = 2
  }

  export enum RateIncrease {
    Percent = 0,
    Rial = 1
  }